import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {DcpAppliedCouponsComponent} from '@app/shared/coupon/applied-coupons/dcp-applied-coupons.component';
import {DcpCartCouponComponent} from '@app/shared/coupon/dcp-cart-coupon.component';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {FormErrorsModule} from '@spartacus/storefront';

import '@sapudex/web-components/dist/Button.js';
import '@sapudex/web-components/dist/TextField.js';
import '@ui5/webcomponents/dist/Icon.js';

@NgModule({
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CartCouponComponent: {
          component: DcpCartCouponComponent,
        },
      },
    }),
    ReactiveFormsModule,
    FormErrorsModule,
    I18nModule,
    DcpCartCouponComponent,
    DcpAppliedCouponsComponent,
  ],
  exports: [DcpCartCouponComponent, DcpAppliedCouponsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DcpCartCouponModule {}
